import c from 'classnames';
import { up } from 'styled-breakpoints';
import styled from 'styled-components';
import { FlexRow } from 'src/components/layout/flex-row';
import { inputFocusBorder, labelTextStyle } from 'src/theme/sub-themes/inputs-theme';
import { Icon } from '../icon';

export const StyledInputLabel = styled.span`
  ${labelTextStyle}
`;

const CaretIcon = styled(Icon)`
  display: flex;
  align-items: center;

  svg {
    path {
      fill: ${({ theme }) => theme.colors.casper};
    }
  }
`;

const InputHolder = styled(FlexRow)`
  -webkit-transition: border 150ms, box-shadow 150ms;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  border: solid 1px #98a9bc40;
  color: ${({ theme }) => theme.colors.smalt};
  cursor: pointer;
  font-family: ${({ theme }) => theme.font.regular};
  font-size: 13px;
  height: 38px;
  justify-content: space-between;
  letter-spacing: normal;
  line-height: 15px;
  outline: none;
  padding: 11px;
  position: relative;
  transition: border 150ms, box-shadow 150ms;
  width: 100%;

  ${up('md')} {
    padding: 8px 10px 8px 10px;
    height: 34px;
    max-width: 390px;
  }

  &.active {
    ${inputFocusBorder};

    ${CaretIcon} {
      transition: all 0.2s ease;
      transform: rotate(180deg);
    }
  }

  strong {
    font-family: ${({ theme }) => theme.font.medium};
    font-weight: 500;
  }
`;

type Props = {
  label: string;
  onClick: VoidFunction;
  active: boolean;
  value: JSX.Element;
  'data-lgg-id'?: string;
  showCaret?: boolean;
};

export const GenericInput = ({
  label,
  onClick,
  active,
  value,
  showCaret,
  ...rest
}: Props) => {
  return (
    <div id="generic-input">
      <StyledInputLabel data-lgg-id="generic-input-label">{label}</StyledInputLabel>
      <InputHolder
        onClick={onClick}
        className={c({ active: active })}
        data-lgg-id={rest['data-lgg-id']}
      >
        {value}
        {showCaret ? <CaretIcon type="arrowdown" /> : null}
      </InputHolder>
    </div>
  );
};
